export default __webpack_public_path__ + "static/media/Tennis_11.cc73d433.png";